module.exports = __webpack_public_path__ + "static/media/authBg.bce9a602.svg";